"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const supportsLevelFactory_1 = require("./supportsLevelFactory");
exports.createLogger = (options) => {
    const supportsLevel = supportsLevelFactory_1.supportsLevelFactory(options);
    const supportsDebug = supportsLevel("DEBUG");
    const supportsInfo = supportsLevel("INFO");
    const supportsWarn = supportsLevel("WARN");
    const supportsError = supportsLevel("ERROR");
    return {
        debug(message) {
            if (supportsDebug) {
                console.debug(message);
            }
        },
        info(message) {
            if (supportsInfo) {
                console.info(message);
            }
        },
        warn(message) {
            if (supportsWarn) {
                console.warn(message);
            }
        },
        error(message) {
            if (supportsError) {
                console.error(message);
            }
        }
    };
};
//# sourceMappingURL=createLogger.js.map